import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

//css
import { Button, Table } from "react-bootstrap";

//pages
import AddFollowUpPlace from "./AddFollowUpPlace.js";
import EditFollowUpPlace from "./EditFollowUpPlace.js";
import { Loading, AppPagination } from "../../components/Index.js";
import { FollowUpPlaceService } from "../../../services/FollowUpPlaceService.js";
import AppNav from "../../../header/AppNav";
import ConfirmModal from "../../../components/ConfirmModal";
import AlertModal from "../../../components/AlertModal";

function FollowUpPlaces() {
  const [addModalShow, setAddModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    cur: 1,
    max: 1,
  });

  // Modal states
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [confirmModalData, setConfirmModalData] = useState({ title: '', message: '', onConfirm: null });
  const [alertModalData, setAlertModalData] = useState({ title: '', message: '', type: 'info' });

  const [followUpPlace, setFollowUpPlace] = useState([]);

  const getFollowUpPlace = async () => {
    setLoading(true);
    try {
      const res = await FollowUpPlaceService.getAllFollowUpPlaces();
      setFollowUpPlace(Array.isArray(res) ? res : []);
      setLoading(false);
    } catch (error) {
      setAlertModalData({
        title: 'Error',
        message: error.message || 'Failed to load follow up places',
        type: 'error'
      });
      setShowAlertModal(true);
      setLoading(false);
    }
  };

  const handleDeleteClick = (id, name) => {
    setConfirmModalData({
      title: 'Confirm Delete',
      message: `Are you sure you want to delete "${name}"?`,
      onConfirm: () => confirmDeleteFollowUpPlace(id)
    });
    setShowConfirmModal(true);
  };

  const confirmDeleteFollowUpPlace = async (id) => {
    setShowConfirmModal(false);
    setLoading(true);
    try {
      const res = await FollowUpPlaceService.deleteFollowUpPlace(id);
      if (res.status === 200) {
        setAlertModalData({
          title: 'Success',
          message: res.message || 'Follow up place deleted successfully!',
          type: 'success'
        });
        setShowAlertModal(true);
        getFollowUpPlace();
      } else {
        setAlertModalData({
          title: 'Error',
          message: 'Error while deleting follow up place',
          type: 'error'
        });
        setShowAlertModal(true);
      }
    } catch (error) {
      setAlertModalData({
        title: 'Error',
        message: error.message || 'Failed to delete taluk',
        type: 'error'
      });
      setShowAlertModal(true);
    } finally {
      setLoading(false);
    }
  };

  const changePage = (page) => {
    setPagination({ ...pagination, cur: page });
    getFollowUpPlace();
  };
  useEffect(() => {
    getFollowUpPlace();
  }, []);

  return (
    <div>
      <AppNav />
      <h1 className="list-style">Follow Up Places</h1>
      <div className="list-table-style">
        <div className="add-button">
          <Button onClick={() => setAddModalShow(true)}>Add Follow Up Place</Button>
          <AddFollowUpPlace
  show={addModalShow}
  onHide={() => setAddModalShow(false)}
  onClose={(result) => {
    getFollowUpPlace();
    if (result) { 
      setAlertModalData({
        title: result.status === "success" ? "Success" : "Error",
        message: result.message,
        type: result.status,
      });
      setShowAlertModal(true);
    }
  }}
/>
        </div>
        <Table striped bordered hover className="professional-table">
          <thead>
            <tr>
              <th>Sl No</th>  
              <th className="list-item-align-center">Follow Up Place</th>
              <th className="list-item-align-center">Edit</th>
              {/* <th className="list-item-align-center">Delete</th> */}
            </tr>
          </thead>
          <tbody>
            {!loading &&
              followUpPlace.map((i, index) => (
                <tr key={i.id}>
                  <td>{index + 1}</td>
                  <td className="list-item-align-center">{i.name}</td>
                  <td className="list-item-align-center">
                  <EditFollowUpPlace
  followUpPlace={i}
  onClose={(result) => {
    getFollowUpPlace();
    if (result) {
      setAlertModalData({
        title: result.status === "success" ? "Success" : "Error",
        message: result.message,
        type: result.status,
      });
      setShowAlertModal(true);
    }
  }}
/>

                  </td>
                  {/* <td className="list-item-align-center">
                    <FontAwesomeIcon
                      icon={faTrash}
                      onClick={(e) => handleDeleteClick(i.id, i.taluk)}
                      size="lg"
                      className="action-icon delete-icon"
                      title="Delete Taluk"
                    />
                  </td> */}
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      {followUpPlace.length < 1 && (
        <h3 style={{ color: "#e77225", textAlign: "center" }}>List is empty</h3>
      )}
      {loading && <Loading />}
      <div className="d-flex justify-content-center my-3">
        <AppPagination
          curPage={pagination.cur}
          maxPage={pagination.max}
          changePage={changePage}
        />
      </div>

      {/* Confirm Modal */}
      <ConfirmModal
        show={showConfirmModal}
        title={confirmModalData.title}
        message={confirmModalData.message}
        onConfirm={confirmModalData.onConfirm}
        onCancel={() => setShowConfirmModal(false)}
      />

      {/* Alert Modal */}
      <AlertModal
        show={showAlertModal}
        title={alertModalData.title}
        message={alertModalData.message}
        type={alertModalData.type}
        onHide={() => setShowAlertModal(false)} 
      />
    </div>
  );
}

export default FollowUpPlaces;
